import React from "react";

interface LoadingProps {
  isInline?: boolean;
}

export default function Loading({ isInline = false }: LoadingProps) {
  return (
    <div className={isInline
      ? "d-flex align-items-center gap-3"
      : "d-flex flex-column align-items-center p-5"}
    >
      <h3>Loading...</h3>
      <div className="spinner-border ml-auto"></div>
    </div>
  );
}
